export const PROVINCE_DIR = {
  安徽: 'anhui',
  重庆: 'chongqing',
  广东: 'guangdong',
  海南: 'hainan',
  河南: 'henan',
  江苏: 'jiangsu',
  辽宁: 'liaoning',
  青海: 'qinghai',
  山西: 'shanxi',
  台湾: 'taiwan',
  新疆: 'xinjiang',
  浙江: 'zhejiang',
  澳门: 'aomen',
  福建: 'fujian',
  广西: 'guangxi',
  河北: 'hebei',
  湖北: 'hubei',
  江西: 'jiangxi',
  内蒙古: 'neimenggu',
  山东: 'shandong',
  陕西: 'shanxi1',
  天津: 'tianjin',
  西藏: 'xizang',
  北京: 'beijing',
  甘肃: 'gansu',
  贵州: 'guizhou',
  黑龙江: 'heilongjiang',
  湖南: 'hunan',
  吉林: 'jilin',
  宁夏: 'ningxia',
  上海: 'shanghai',
  四川: 'sichuan',
  香港: 'xianggang',
  云南: 'yunnan',
};

export const GUANGDONG_CITY_DIR = {
  江门市: 'jiangmen',
  茂名市: 'maoming',
  惠州市: 'huizhou',
  揭阳市: 'jieyang',
  广州市: 'guangzhou',
  东莞市: 'dongguan',
  清远市: 'qingyuan',
  梅州市: 'meizhou',
  佛山市: 'foshan',
  汕头市: 'shantou',
  河源市: 'heyuan',
  汕尾市: 'shanwei',
  韶关市: 'shaoguan',
  深圳市: 'shenzhen',
  阳江市: 'yangjiang',
  云浮市: 'yunfu',
  湛江市: 'zhanjiang',
  肇庆市: 'zhaoqing',
  中山市: 'zhongshan',
  珠海市: 'zhuhai',
  潮州市: 'chaozhou',
};


export const GUANGDDONG_CITY_LOCATION = {
  广州市: [113.53, 23.36],
  佛山市: [112.98, 23.01],
  东莞市: [113.85, 23.01],
  中山市: [113.38, 22.52],
  江门市: [112.70, 22.21],
  阳江市: [111.80, 21.95],
  茂名市: [110.99, 21.88],
  湛江市: [110.14, 21.25],
  珠海市: [113.34, 22.07],
  汕头市: [116.59, 23.26],
  韶关市: [113.60, 24.82],
  肇庆市: [112.25, 23.49],
  梅州市: [116.13, 24.29],
  惠州市: [114.52, 23.12],
  汕尾市: [115.46, 22.91],
  河源市: [114.90, 23.95],
  清远市: [113.01, 24.11],
  潮州市: [116.83, 23.66],
  揭阳市: [116.01, 23.27],
  云浮市: [111.85, 22.82],
  深圳市: [114.07, 22.62],

  高明区: [112.67229288536669, 22.80348495838345],
  南海区: [113.03968108583868, 23.133644535304628],
  三水区: [112.893806283366, 23.303747005262608],
  顺德区: [113.18010660606978, 22.85540762840548],
  禅城区: [113.06880843030443, 22.997591201069106],

  海珠区: [113.33581312855117, 23.09301292187505],
  番禺区: [113.39535796657987, 22.930409975911484],
  白云区: [113.34510124800715, 23.289560623963684],
  从化市: [113.6718100107937, 23.68941081969576],
  花都区: [113.16252525716158, 23.428672146773756],
  黄埔区: [113.49189056551855, 23.107554825284144],
  荔湾区: [113.22685702392587, 23.107748334472703],
  萝岗区: [113.49441661458347, 23.221823631510457],
  南沙区: [113.58158938476572, 22.712394269531284],
  天河区: [113.3892945159647, 23.172155032948403],
  越秀区: [113.2671310440341, 23.144129088423327],
  增城市: [113.75303103515635, 23.31861337931747],

  紫金县: [115.06208054895305, 23.49584318700136],
  东源县: [114.79808686052608, 23.93497812311666],
  和平县: [114.96728576936162, 24.442725260529922],
  连平县: [114.54578075984887, 24.34330479978394],
  龙川县: [115.36517119201054, 24.32561254131768],
  源城区: [114.63253434461824, 23.67747472743058],

  博罗县: [114.30400872903975, 23.384744950743187],
  惠城区: [114.46099701580002, 23.15901459077663],
  惠东县: [114.90644543902124, 22.947204557141916],
  惠阳区: [114.51271740835355, 22.788196376116108],
  龙门县: [114.13926040025696, 23.690305067904582],

  江海区: [113.1385222460938, 22.547040998046914],
  蓬江区: [113.03681887695329, 22.645239636962927],
  台山市: [112.85772400099127, 21.990460085471114],
  开平市: [112.53520421826788, 22.386144251446794],
  恩平市: [112.25883760602692, 22.205593488281284],
  鹤山市: [112.74875822544652, 22.667098382719523],
  新会区: [113.0199684907671, 22.40671054261367],

  榕城区: [116.36244304687517, 23.503863605468773],
  惠来县: [116.1744421279458, 23.02944022400105],
  揭东县: [116.34801720052101, 23.671883364583364],
  揭西县: [115.94299659254823, 23.504848521334154],
  普宁市: [116.03881050358969, 23.28258330035898],

  电白县: [111.21356106445326, 21.620055375217053],
  高州市: [110.97231693695406, 22.01849521774198],
  化州市: [110.51834519975155, 21.80555910884237],
  茂港区: [110.97766525146491, 21.549716840332074],
  茂南区: [110.8468671306297, 21.66723188729324],
  信宜市: [111.1359938260249, 22.44780860504876],

  丰顺县: [116.23541841746814, 23.888633665064138],
  蕉岭县: [116.21689805989611, 24.70970725781255],
  梅江区: [116.11120730468787, 24.2757678383621],
  梅县: [116.15239957481995, 24.351711314302907],
  大埔县: [116.67307408916191, 24.343417614025338],
  平远县: [115.92309922615873, 24.69597022252159],
  五华县: [115.5987599876647, 23.79904350370069],
  兴宁市: [115.77415186007745, 24.228857291827634],

  佛冈县: [113.55941024188704, 23.885487381009643],
  连南瑶族自治县: [112.28402541992189, 24.560663940290212],
  连山壮族瑶族自治县: [112.09551638671876, 24.51527413080197],
  连州市: [112.43280182313016, 24.89810981768701],
  清城区: [113.13429817694494, 23.642558145029955],
  清新县: [112.91236714884027, 23.884147093508403],
  阳山县: [112.6908997146268, 24.479651403862878],
  英德市: [113.358984404297, 24.244805440227665],

  南澳县: [117.06836314152672, 23.410084018629833],
  濠江区: [116.68541192940862, 23.289593732421903],
  金平区: [116.62401090073541, 23.397706884420995],
  龙湖区: [116.73282426682701, 23.384772236778893],
  澄海区: [116.81570483276379, 23.52557754284671],
  潮阳区: [116.49550318319535, 23.3384861560906],
  潮南区: [116.41797411987328, 23.173684995239274],

  海丰县: [115.29069078548584, 22.91929524844694],
  陆丰市: [115.82078790784628, 22.971127184937874],
  陆河县: [115.63450581891763, 23.254732107840432],
  城区: [115.4476927986655, 22.76879686759446],

  乐昌市: [113.17437739716694, 25.22902710556292],
  南雄市: [114.36702339167681, 25.198657484425123],
  曲江区: [113.5967870708551, 24.61878054069014],
  仁化县: [113.8399386095356, 25.166575401808693],
  乳源瑶族自治县: [113.1642196025619, 24.79481516229109],
  始兴县: [114.09521981589398, 24.815016676037423],
  翁源县: [114.00057453073606, 24.404125207288274],
  武江区: [113.33854580336099, 24.698551413178105],
  新丰县: [114.17206859451602, 24.08745058463545],
  浈江区: [113.56412546647901, 24.881043729015303],

  南山区: [113.93393606445318, 22.544898175781277],
  盐田区: [114.27860415527353, 22.596655703450555],
  宝安区: [113.9522853978431, 22.693021944463343],
  福田区: [114.05067315987722, 22.546437168526825],
  龙岗区: [114.33158934661877, 22.658717877929732],
  罗湖区: [114.13707904947925, 22.579775779947948],

  阳春市: [111.73967106992627, 22.27872439058211],
  阳东县: [112.02121818806489, 21.96004117159266],
  江城区: [111.91470478092064, 21.733742431711256],
  阳西县: [111.62475022242313, 21.67598145324163],

  罗定市: [111.52701325410925, 22.683811800730552],
  新兴县: [112.24176157788834, 22.624156461766127],
  郁南县: [111.63661200168197, 23.022768340440578],
  云安县: [111.91532855102552, 22.839926435058644],
  云城区: [112.17898920194416, 22.958733363826358],

  赤坎区: [110.36793864720396, 21.281739535773045],
  雷州市: [110.00888413497933, 20.762421624725366],
  廉江市: [110.22405615907313, 21.677940254136047],
  麻章区: [110.41657924353979, 21.051695830153278],
  坡头区: [110.51064564305723, 21.25514970511501],
  遂溪县: [110.09156454859095, 21.238925300489225],
  吴川市: [110.7048771258062, 21.46316762177584],
  霞山区: [110.38569879464292, 21.17016461458338],
  徐闻县: [110.28007710280022, 20.467667257425777],

  德庆县: [111.95693367938718, 23.28380059465149],
  鼎湖区: [112.60898604593221, 23.2079970106412],
  端州区: [112.46144011021215, 23.119156371930845],
  封开县: [111.74438172211757, 23.55537353722166],
  高要市: [112.44965261182188, 23.00098129627408],
  广宁县: [112.42292480268442, 23.66628027463946],
  怀集县: [112.1448816998489, 23.919859727570593],
  四会市: [112.68747916637076, 23.43175818702654],


  斗门区: [113.26288273271282, 22.202257332613073],
  金湾区: [113.2521108819903, 22.047642162212207],
  香洲区: [113.50915671123816, 22.146760812731164],

  潮安县: [116.64601057874198, 23.82847964807777],
  饶平县: [116.92072998583048, 23.812574162875357],
  湘桥区: [116.67358560997614, 23.71192987650246],

  // 省份
  甘肃: [103.73, 36.03],
  青海: [101.74, 36.56],
  四川: [104.06, 30.67],
  河北: [114.48, 38.03],
  云南: [102.73, 25.04],
  贵州: [106.71, 26.57],
  湖北: [114.31, 30.52],
  河南: [113.65, 34.76],
  山东: [117, 36.65],
  江苏: [118.78, 32.04],
  安徽: [117.27, 31.86],
  浙江: [120.19, 30.26],
  江西: [115.89, 28.68],
  福建: [119.3, 26.08],
  广东: [113.23, 23.16],
  湖南: [113, 28.21],
  海南: [110.35, 20.02],
  辽宁: [123.38, 41.8],
  吉林: [125.35, 43.88],
  黑龙江: [126.63, 45.75],
  山西: [112.53, 37.87],
  陕西: [108.95, 34.27],
  台湾: [121.30, 25.03],
  北京: [116.46, 39.92],
  上海: [121.48, 31.22],
  重庆: [106.54, 29.59],
  天津: [117.2, 39.13],
  内蒙古: [111.65, 40.82],
  广西: [108.33, 22.84],
  西藏: [91.11, 29.97],
  宁夏: [106.27, 38.47],
  新疆: [87.68, 43.77],
  香港: [114.17, 22.28],
  澳门: [113.54, 22.19],
};
